import { Component } from '@angular/core';

@Component({
  selector: 'app-download-svg',
  standalone: true,
  template: `
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1130_10537"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1130_10537)">
        <path
          d="M10.0003 12.8237L6.60928 9.43267L7.38345 8.67475L9.45866 10.75V3.41663H10.542V10.75L12.6172 8.67475L13.3914 9.43267L10.0003 12.8237ZM5.75095 15.5833C5.37553 15.5833 5.05935 15.4538 4.80241 15.1948C4.54546 14.9357 4.41699 14.6186 4.41699 14.2435V12.9839H5.50033V14.2435C5.50033 14.3077 5.52706 14.3664 5.58053 14.4198C5.63387 14.4732 5.69262 14.5 5.75678 14.5H14.2439C14.308 14.5 14.3668 14.4732 14.4201 14.4198C14.4736 14.3664 14.5003 14.3077 14.5003 14.2435V12.9839H15.5837V14.2435C15.5837 14.6186 15.4541 14.9357 15.1949 15.1948C14.9357 15.4538 14.6185 15.5833 14.243 15.5833H5.75095Z"
          fill="#EA5B0C"
        />
      </g>
    </svg>
  `,
})
export class DownloadSvgComponent {}
